import AuthComponent from '../../login/component/auth-provider';
import { observable } from 'mobx';
import NominationDataService from "../services/nomination-data-services";
import serviceDef from "../services/nomination-serviceDef.json";
import { isFlowCalAutomated, isTBossAutomated } from '../utils/rows';
class NominationScreenStore {
    @observable NominationData = {
        GridData: []
    };
    getUserDetails = async () => {
        return AuthComponent.getUserNamePostLogin().then((response) => {
            let nominationRole = '';
            if (response.roles.some(item => "NominationsReadWriteOps" === item)) {
                nominationRole = 'OPS';
            }
            else if (response.roles.some(item => "NominationsReadWriteAsset" === item)) {
                nominationRole = 'ASSET';
            }
            else if (response.roles.some(item => "NominationsReadOnlyComm" === item)) {
                nominationRole = 'COMM';
            }
            else if (response.roles.some(item => "NominationsReadOnly" === item)) {
                nominationRole = 'RO'
            }
            return {
                userName: response.userName,
                displayName: response.displayName,
                nominationRole: nominationRole
            }
        });
    }

    getNominationData = async (facility, month) => {
        let dataDef = serviceDef.filter((def) => def.Fact === facility);
        const IsFlowcalAutomated = isFlowCalAutomated(month)
        const IsTBOSSAutomated = isTBossAutomated(month)

        if (Object.keys(dataDef).length > 0)
            Object.assign(dataDef[0], { Date: month, IsFlowcalAutomated, IsTBOSSAutomated });

        try {
            if (Object.keys(dataDef).length > 0) {
                let requestObj = dataDef[0];
                var { data } = await NominationDataService.getNominationData(requestObj);
                this.NominationData.GridData = data;
                return data;
            } else {
                return {};
            }

        } catch (error) {
            window.toastr.error(error);
        }
    };

    getAllData = async (month) => {
        const { getNominationData } = NominationDataService
        let propaneDataDef = serviceDef.filter(def => def.Fact === 'Propane')
        let butaneDataDef = serviceDef.filter(def => def.Fact === 'Butane')
        let isoButaneDataDef = serviceDef.filter(def => def.Fact === 'Iso-Butane')
        let normalButaneDataDef = serviceDef.filter(def => def.Fact === 'Normal Butane')
        let condensateDataDef = serviceDef.filter(def => def.Fact === 'Condensate')
        const isFlowcalAutomated = isFlowCalAutomated(month)
        const isTBOSSAutomated = isTBossAutomated(month)

        if (Object.keys(propaneDataDef)?.length)
            Object.assign(propaneDataDef[0], { Date: month, IsFlowcalAutomated: isFlowcalAutomated, IsTBOSSAutomated: isTBOSSAutomated });
        if (Object.keys(butaneDataDef)?.length)
            Object.assign(butaneDataDef[0], { Date: month, IsFlowcalAutomated: isFlowcalAutomated, IsTBOSSAutomated: isTBOSSAutomated });
        if (Object.keys(isoButaneDataDef)?.length)
            Object.assign(isoButaneDataDef[0], { Date: month, IsFlowcalAutomated: isFlowcalAutomated, IsTBOSSAutomated: isTBOSSAutomated });
        if (Object.keys(normalButaneDataDef)?.length)
            Object.assign(normalButaneDataDef[0], { Date: month, IsFlowcalAutomated: isFlowcalAutomated, IsTBOSSAutomated: isTBOSSAutomated });
        if (Object.keys(condensateDataDef)?.length)
            Object.assign(condensateDataDef[0], { Date: month, IsFlowcalAutomated: isFlowcalAutomated, IsTBOSSAutomated: isTBOSSAutomated });

        try {
            const propanePayload = propaneDataDef[0]
            const butanePayload = butaneDataDef[0]
            const isoButanePayload = isoButaneDataDef[0]
            const normalButanePayload = normalButaneDataDef[0]
            const condensatePayload = condensateDataDef[0]

            const [
                propaneRes,
                butaneRes,
                isoButaneRes,
                normalButaneRes,
                condensateRes
            ] = await Promise.all([
                getNominationData(propanePayload),
                getNominationData(butanePayload),
                getNominationData(isoButanePayload),
                getNominationData(normalButanePayload),
                getNominationData(condensatePayload)
            ])
            return {
                rawPropaneData: propaneRes?.data || [],
                rawButaneData: butaneRes?.data || [],
                rawIsoButaneDta: isoButaneRes?.data || [],
                rawNormalButaneData: normalButaneRes?.data || [],
                rawCondensateData: condensateRes?.data || []
            }
        } catch (err) {
            console.log(err)
            window.toastr.error(err)
            return {}
        }
    };
    

     saveNominationData = async (saveData) => {
        try {
            if (Object.keys(saveData).length > 0) {
                let res = await NominationDataService.saveNominationData(saveData);
                if (!res)
                    window.toastr.error('Data is not updated successfully');
            } else {
                window.toastr.error('Getting error; data is not updated');
            }

        } catch (error) {
            window.toastr.error(error);
        }
    };

    getNominationAudit = async (auditData) => {
        try {
            if (Object.keys(auditData).length > 0) {
                var { data } = await NominationDataService.getNominationAudit(auditData);
                if (Object.keys(data).length > 0)
                    return data;
                else {
                    window.toastr.error('No data available');
                    return {};
                }
            } else {
                window.toastr.error('No data available for update');
            }

        } catch (error) {
            window.toastr.error(error);
        }
    };
}

export default new NominationScreenStore();